import {ONBOARDING_STATUS, ONBOARDING_TYPE_ENUM, KYB_STATUS} from '../consts'
import HTTP from './HttpService'

export const handleKybPending = (router, store, customerData, kybData) => {
  store.commit('customer/setKeyValue', { prop: 'firstName', value: customerData.firstName })

  if (kybData && kybData.status === KYB_STATUS.PENDING) {
    if (customerData.customerBusinessData && customerData.customerBusinessData.businessUbos && customerData.customerBusinessData.businessUbos.uboResponseList) {
      store.commit('customer/setKeyValue', { prop: 'businessOwners', value: customerData.customerBusinessData.businessUbos.uboResponseList })
    }
    router.push('/partner/verificationCenter')
  } else if (kybData && [KYB_STATUS.NEW, KYB_STATUS.RESUBMIT].includes(kybData.status)) {
    router.push('/partner/kybThankYou')
  } else {
    router.push('/partner/kybPending?isPolling=false')
  }
}

export const handleDuringRegistration = (router, lastStepData, isMultibusiness) => {
  if (!lastStepData && !isMultibusiness) return
  if (isMultibusiness && (!lastStepData || (lastStepData && lastStepData.step === 0))) {
    router.push({ name: 'partner-business' })
    return
  }
  const routeMap = {
    0: 'partner-personal-details',
    1: 'partner-personal-details',
    2: 'partner-business',
    3: 'plan',
    4: 'plan' // in the future we will change it to 'review'
  }

  const routeName = routeMap[lastStepData.step]
  if (routeName) {
    router.push({ name: routeName })
  }
}

export const handleOnboardingStatus = (router, store, onboardingStatus, nameTooLong, customerData, lastStepData, onboardingTypeEnum) => {
  const isMultibusiness = onboardingTypeEnum !== ONBOARDING_TYPE_ENUM.STANDARD && onboardingTypeEnum !== null
  if (isMultibusiness) {
    store.commit('onboarding/setKeyValue', {
      prop: 'isMultiBusinessFlow',
      value: true
    })
  }

  if (onboardingStatus === ONBOARDING_STATUS.DURING_REGISTRATION) {
    if (onboardingTypeEnum === ONBOARDING_TYPE_ENUM.NO_CONTINUE_BLOCK) {
      router.push('/partner/noContinueDone')
    } else if (onboardingTypeEnum === ONBOARDING_TYPE_ENUM.NO_CONTINUE_PRIMARY) {
      router.push('/partner/noContinuePrimary')
    } else {
      handleDuringRegistration(router, lastStepData, isMultibusiness)
    }
    return
  }

  switch (onboardingStatus) {
    case ONBOARDING_STATUS.KYC_PASSED:
      router.push(nameTooLong ? '/partner/debitCardName' : '/partner/error')
      break
    case ONBOARDING_STATUS.KYC_FIRST_FAILED:
      router.push('/partner/checkDocs')
      break
    case ONBOARDING_STATUS.KYC_FAILED_UPLOADED_DOCS:
      router.push('/partner/noContinueChecking')
      break
    case ONBOARDING_STATUS.KYB_PENDING:
      handleKybPending(router, store, customerData, customerData.kybData)
      break
    case ONBOARDING_STATUS.COMPLETED:
      router.push({name: 'accountExists'})
      break
    default:
      router.push('/partner/noContinueDone')
      break
  }
}

export const loginUser = (partnerToken) => {
  return HTTP.get(`v3/onboardingPartner?token=${partnerToken}`)
}



// WEBPACK FOOTER //
// ./src/services/auth.js